module.exports = __webpack_public_path__ + "img/leads_logo_black.9ab7254e.svg";